import Link from "next/link";
import { FC } from "react";

import { isOnline, removeInstLink } from "@/features/profile/utils";
import { Typography } from "@/shared/ui";
import { calculateAge } from "@/utils";

import { ControlButtons } from "../../../control-buttons";
import { Tag } from "../../../tag";

import styles from "./profile-info-short.module.scss";
import { ProfileInfoShortProps } from "./profile-info-short.types";

const ProfileInfoShort: FC<ProfileInfoShortProps> = ({
  id,
  firstName,
  dateOfBirth,
  lastSeen,
  isFreeTonight,
  currentLocation,
  locationResidence,
  visit,
  socialLinks,
  admiredByMe,
}) => {
  const visitLabel = [visit?.state ?? visit?.city, visit?.country].join(", ");

  return (
    <div className={styles.profileInfoShort}>
      <div className={styles.rowCenter}>
        <div className={styles.mainInfo}>
          <Typography bold variant="large-title" className={styles.name}>
            {firstName}
          </Typography>
          <Typography bold variant="footnote" className={styles.age}>
            {calculateAge(dateOfBirth)}
          </Typography>
          {isOnline(lastSeen) && <span className={styles.onlineDot} />}
        </div>

        {isFreeTonight && <Tag variant="green" label="Free tonight" />}
      </div>

      <div className={styles.rowTop}>
        <div className={styles.col}>
          {socialLinks?.instagram && (
            <Link href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className={styles.instLink}>
              <Typography bold variant="footnote">
                {removeInstLink(socialLinks.instagram)}
              </Typography>
            </Link>
          )}

          <div className={styles.location}>
            <Typography bold as="span" variant="footnote" className={styles.value}>
              {visit
                ? visitLabel
                : currentLocation
                ? currentLocation.label
                : locationResidence
                ? locationResidence.label
                : null}
            </Typography>
          </div>
        </div>

        <ControlButtons {...{ id, admiredByMe }} size="small" />
      </div>
    </div>
  );
};

export { ProfileInfoShort };
